import Component from '@bythepixel/component-loader';
import Splide from '@splidejs/splide';
import windowMatchMedia from '@Front/constants/windowMatchMedia';
import { EVENT_NAMES as TAB_EVENTS } from '@Core/components/sectionTabs/events';
import { splideOptions, selectors } from './config';

export default class VehicleCardGrid extends Component {
  static selector = '[data-comp-vehicle-card-grid]';
  static loaderPriority = 'in-view';

  constructor(containerEl) {
    super(containerEl);

    this.gridContainer = this.$container.querySelector(selectors.grid);
    this.slider = new Splide(this.gridContainer, splideOptions).mount();

    // If this component exists within the SectionVehicleTypeTabs component,
    // we need to refresh the slider to allow Splide to recalculate schtuff
    this.isInTabs = this.$container.dataset.isInTabs === 'true';

    this.mount();
  }

  attachListeners() {
    window.addEventListener(TAB_EVENTS.TAB_UPDATED, (e) => {
      if (!this.isInTabs) return;

      const activeTab = e.detail;
      const sliderIsInActiveTab = activeTab.contains(this.$container);

      if (!sliderIsInActiveTab) return;

      this.slider.refresh();
    });
  }

  mount() {
    this.attachListeners();
  }
}
